module.exports = __webpack_public_path__ + "2474f8170acf6cd9671d6dc64518548c.woff2";